"use client";

import { c as _c } from "react/compiler-runtime";
import { Badge } from "@/components/ui/badge";
import type { RecentActivity } from "@/hooks/useMetricsRecentActivity";
import { formatDuration, formatRelativeTime } from "@/lib/utils";
import { getWorkflowEditUrl, getWorkflowHistoryUrl } from "@/lib/utils/urlHelpers";
import { IconArrowRotateClockwise, IconCheckmark1, IconCloseCircleDashed, IconClock, IconLiveActivity } from "@central-icons-react/square-outlined-radius-0-stroke-1.5";
import Link from "next/link";
interface RecentActivityFeedProps {
  activities: RecentActivity[];
  isLoading?: boolean;
  hideHeader?: boolean;
  maxItems?: number;
}
export function RecentActivityFeed(t0) {
  const $ = _c(16);
  const {
    activities,
    isLoading,
    hideHeader,
    maxItems
  } = t0;
  let t1;
  if ($[0] !== activities || $[1] !== maxItems) {
    t1 = maxItems ? activities.slice(0, maxItems) : activities;
    $[0] = activities;
    $[1] = maxItems;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const displayActivities = t1;
  if (isLoading) {
    const t2 = hideHeader ? "" : "border-ds-border-default bg-ds-surface-card rounded-xl border p-6";
    let t3;
    if ($[3] !== hideHeader) {
      t3 = !hideHeader && <h3 className="mb-4 flex items-center gap-2 text-xl font-semibold"><IconLiveActivity className="h-6 w-6" />Recent Activity</h3>;
      $[3] = hideHeader;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    let t4;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <div className="bg-ds-neutral-100 dark:bg-ds-neutral-800 h-96 animate-pulse rounded-lg" />;
      $[5] = t4;
    } else {
      t4 = $[5];
    }
    let t5;
    if ($[6] !== t2 || $[7] !== t3) {
      t5 = <div className={t2}>{t3}{t4}</div>;
      $[6] = t2;
      $[7] = t3;
      $[8] = t5;
    } else {
      t5 = $[8];
    }
    return t5;
  }
  let t2;
  if ($[9] !== hideHeader) {
    t2 = !hideHeader && <div className="mb-3 flex items-center justify-between gap-2"><h3 className="text-ds-text-primary flex items-center gap-2 text-lg font-semibold"><IconLiveActivity className="h-5 w-5" />Recent Activity</h3><Link href={getWorkflowHistoryUrl()} className="text-ds-text-muted hover:text-ds-text-secondary inline-flex items-center gap-1 text-xs dark:hover:text-zinc-300"><IconClock className="h-3 w-3" />View all</Link></div>;
    $[9] = hideHeader;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] !== displayActivities) {
    t3 = displayActivities.length === 0 ? <div className="body-sm flex h-20 items-center justify-center">No recent activity</div> : <div className="space-y-2">{displayActivities.map(_temp)}</div>;
    $[11] = displayActivities;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== t2 || $[14] !== t3) {
    t4 = <div>{t2}{t3}</div>;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  return t4;
}
function _temp(activity) {
  return <Link key={activity.runId} href={getWorkflowEditUrl(activity.workflowId)} className="rounded-ds-sm shadow-ds-soft border-ds-border-default dark:hover:bg-ds-neutral-800/70 bg-ds-surface-card hover:bg-ds-surface-hover flex items-center gap-3 border px-3 py-3 transition-colors">{activity.status === "success" ? <IconCheckmark1 className="h-4 w-4 shrink-0 text-green-500" /> : activity.status === "failure" ? <IconCloseCircleDashed className="h-4 w-4 shrink-0 text-red-500" /> : <IconArrowRotateClockwise className="h-4 w-4 shrink-0 animate-spin text-blue-500" />}<span className="body-sm-medium min-w-0 flex-1 truncate">{activity.workflowName}</span><span className="label-xs shrink-0">{formatRelativeTime(new Date(activity.startedAt))}</span>{activity.durationMs !== null && <span className="mono-xs w-14 shrink-0 text-right tabular-nums">{formatDuration(activity.durationMs)}</span>}<Badge variant={activity.status === "success" ? "success" : activity.status === "failure" ? "destructive" : "info"} className="shrink-0">{activity.status}</Badge></Link>;
}